import React from 'react'
import { Logo } from '../components/simple/logo'
import { Link } from 'react-router-dom'
import { Button } from '../components/simple/button'

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <Link to="/" className="mb-8 no-underline">
        <Logo size="xl" showName />
      </Link>
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-xl">Page not found</p>

      <Button link="/" className="mt-16">
        Go Home
      </Button>
    </div>
  )
}
